import React from 'react';
import { useTranslation } from 'react-i18next';
import { RiContactsFill } from 'react-icons/ri';

import { IoMdLock } from 'react-icons/io';

import { IUserProfileTab } from './UserProfile.model';
import UserProfileView from './UserProfile.view';
import PersonalInfoTab from './UserProfileTabs/PersonalInfoTab/PersonalInfoTab';
import SecurityTab from './UserProfileTabs/SecurityTab/SecurityTab';

type Props = Record<never, never>;

const UserProfile: React.FC<Props> = () => {
  const { t } = useTranslation();

  const tabs: IUserProfileTab[] = [
    {
      key: 'personal-info',
      label: t('userProfile.tabs.personalInfo'),
      icon: RiContactsFill,
      content: <PersonalInfoTab />,
    },
    {
      key: 'security',
      label: t('userProfile.tabs.security'),
      icon: IoMdLock,
      content: <SecurityTab />,
    },
  ];

  return <UserProfileView tabs={tabs}></UserProfileView>;
};

UserProfile.displayName = 'UserProfile';
UserProfile.defaultProps = {};

export default UserProfile;
